var map = {
	"./BackSheet1.svg": "Ks3P",
	"./arrow-down.svg": "zpNP",
	"./arrow-up.svg": "WJf4",
	"./bets-title.svg": "qPjb",
	"./bounties-title.svg": "2rRu",
	"./leaderboard-title.svg": "keMB",
	"./logo.png": "7Otq",
	"./swiftorland-title.svg": "FVa6",
	"./ticket-raffles-title.svg": "JNCl",
	"./twitch-logo.svg": "Gh/C"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1